import { IonCol } from "@ionic/react";
import CancelPopUp from "assets/images/icon/svg/CancelPopUp";
import moment from "moment";
import React, { forwardRef, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { ClipLoader } from "react-spinners";
import "react-datepicker/dist/react-datepicker.css";
import Accounts from "services/Accounts";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import RightArrowThin from "assets/images/icon/svg/RightArrowThin";
import TextInputWithIcon from "../Common/TextInputWithIcon";
import Payment from "services/Payment";

export default function SalaryList({
  employees,
  ekkLanguage,
  totalAmount,
  getEmployees,
  currentWeekStart,
  currentWeekEnd,
  employeeSalary,
  salaryList,
  salaryLoading,
  getEmployeesSalaryList,
  currency,
}) {
  console.log(currency, employeeSalary);
  const dateFormat = useSelector((state) => state.date.format);
  const [totalWorkingHours, setTotalWorkingHours] = useState("00:00:00");
  const [selectedHours, setSelectedHours] = useState(null);

  const [isOpenEditHours, setIsOpenEditHours] = useState(false);
  const onCloseModalEditHours = () => {
    setIsOpenEditHours(false);
  };
  const onOpenModalEditHours = () => setIsOpenEditHours(true);

  const [editHoursLoader, setEditHoursLoader] = useState(false);
  const [isOpenEditHoursModel, setIsOpenEditHoursModel] = useState(false);
  const onCloseModalEditHoursModel = () => {
    setTotalWorkingHours("00:00:00");
    setIsOpenEditHoursModel(false);
  };

  const [isOpenSalaryPayoutModel, setIsOpenSalaryPayoutModel] = useState(false);
  const onCloseSalaryPayoutModel = () => {
    setIsOpenSalaryPayoutModel(false);
  };
  const [salaryPayoutAmount, setSalaryPayoutAmount] = useState("");
  const [salaryPayoutAmountEmpty, setSalaryPayoutAmountEmpty] = useState("");
  const [payoutDescription, setPayoutDescription] = useState("");
  const [salaryPayoutLoader, setSalaryPayoutLoader] = useState(false);
  const [salaryPayoutId, setSalaryPayoutId] = useState(null);

  const onOpenModalEditHoursModel = () => setIsOpenEditHoursModel(true);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px",
      width: "calc(100% - 40px)",
      transition: ".4s all ease",
      borderRadius: 12,
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      transition: ".4s all ease",
      backgroundColor: "rgba(0,0,0,.5)",
      overflow: "auto",
    },
  };

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div
      ref={ref}
      className={`p-3 block mt-4 example-custom-input pl-4 h-[50px] rounded-[5px] bg-F8F8F8  w-full border border-black-500`}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center ">
          {selectedHours?.check_in_time
            ? moment(selectedHours?.check_in_time).format(
                `${dateFormat}-HH:mm:ss`
              )
            : "Select Time and Date"}
        </div>
      </div>
    </div>
  ));

  const ExampleCustomInput2 = forwardRef(({ value, onClick }, ref) => (
    <div
      ref={ref}
      className={`p-3 block mt-4 example-custom-input pl-4 h-[50px] rounded-[5px] bg-F8F8F8  w-full border border-black-500`}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center ">
          {selectedHours?.check_out_time
            ? moment(selectedHours?.check_out_time).format(
                `${dateFormat}-HH:mm:ss`
              )
            : "Select Time and Date"}
        </div>
      </div>
    </div>
  ));

  let dateChanger = (date, type) => {
    let updatedHours;
    if (type === "start") {
      updatedHours = {
        ...selectedHours,
        check_in_time: date,
      };
    } else {
      updatedHours = {
        ...selectedHours,
        check_out_time: date,
      };
    }
    setSelectedHours(updatedHours);

    // Calculate total hours if both dates exist
    if (updatedHours.check_in_time && updatedHours.check_out_time) {
      const start = moment(updatedHours.check_in_time);
      const end = moment(updatedHours.check_out_time);
      const duration = moment.duration(end.diff(start));

      const hours = Math.floor(duration.asHours()).toString().padStart(2, "0");
      const minutes = duration.minutes().toString().padStart(2, "0");
      const seconds = duration.seconds().toString().padStart(2, "0");

      setTotalWorkingHours(`${hours}:${minutes}:${seconds}`);
    }
  };

  const updateHoursSubmit = async () => {
    setEditHoursLoader(true);
    let payload = {
      check_out_time: moment(selectedHours?.check_out_time).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
      check_in_time: moment(selectedHours?.check_in_time).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
    };
    // console.log(payload);
    let response = await Accounts.checkOut(selectedHours?.id, payload);

    if (response.success) {
      getEmployees();
      setEditHoursLoader(false);
      toast.success("Working hours updated successfully");
      onCloseModalEditHours();
      onCloseModalEditHoursModel();
    } else {
      setEditHoursLoader(false);
    }
  };

  const salaryPayoutHandler = async () => {
    if (salaryPayoutAmount === "") {
      setSalaryPayoutAmountEmpty("Please enter amount");
      return;
    }
    setSalaryPayoutLoader(true);
    let payload = {
      amount: salaryPayoutAmount,
      description: payoutDescription,
    };
    let response = await Payment.updateSalaryPayout(salaryPayoutId, payload);
    if (response.success) {
      setSalaryPayoutLoader(false);
      toast.success("Salary payout updated successfully");
      onCloseSalaryPayoutModel();
      getEmployeesSalaryList(employees?.id);
    } else {
      setSalaryPayoutLoader(false);
    }
  };

  return (
    <div className="bg-white">
      <div
        className="px-4 py-[10px]"
        style={{ borderBottom: "1.5px solid rgba(0, 0, 0, 0.1)" }}
      >
        <h6 className="font-bold text-16 pt-4 pb-4">Salary</h6>
        <div className="flex justify-between items-center mb-1">
          <h4 className="font-bold text-16 text-black-1000">
            Salary Type: {employeeSalary?.salary_type}
          </h4>
        </div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="font-bold text-16 text-black-1000">
            Salary Amount: {employeeSalary?.currency}
            {employeeSalary?.amount}
          </h4>
          <div className="flex justify-between items-center">
            <div className="flex justify-end items-center mt-1 z-20">
              <Link
                to={`/salary-payout-list/${employees?.id}`}
                className="text-0086B2 text-12 font-normal flex items-center"
              >
                See More
                <span className="ml-2">
                  <RightArrowThin />
                </span>
              </Link>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <table
            className="table-auto w-full bg-white"
            style={{
              boxShadow: "0px 3px 20px 0px rgba(0, 0, 0, 0.05)",
            }}
          >
            <thead>
              <tr className="border h-[45px] border-r-0 border-l-0 border-D9D9D9 px-4">
                <th className="font-bold text-14">Date</th>
                <th className="font-bold text-14">Amount</th>
                <th className="font-bold text-14">Paid By</th>
              </tr>
            </thead>

            <tbody>
              {salaryList?.length > 0 &&
                salaryList?.map((el, i) => (
                  <tr
                    key={i}
                    className="text-center h-[34px] border border-r-0 border-l-0 border-D9D9D9 px-4"
                    onClick={() => {
                      setSalaryPayoutId(el?.id);
                      setSalaryPayoutAmount(Number(el?.amount).toFixed(2));
                      setPayoutDescription(el?.description);
                      setIsOpenSalaryPayoutModel(true);
                    }}
                  >
                    <td className="font-semibold text-12">
                      {moment(el?.createdAt).format(`${dateFormat}-HH:mm:ss`)}
                    </td>
                    <td className="font-semibold text-12">
                      {Number(el?.amount).toFixed(2)}
                    </td>
                    <td className="font-semibold text-12">
                      {el?.created_by_name}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {salaryList.length === 0 && (
            <>
              <IonCol size="2"></IonCol>
              <IonCol size="8">
                <div
                  className="text-center flex items-center justify-center"
                  style={{ height: "calc(100vh - 420px)" }}
                >
                  <div>
                    <img
                      className="m-auto mb-[10px] mt-5"
                      src="/assets/images/not-found-file.png"
                      alt="emptyCard"
                    />
                    <p className="text-16 font-normal text-222222 mb-[35px]">
                      {ekkLanguage.orderList.notFound}
                    </p>
                  </div>
                </div>
              </IonCol>
            </>
          )}
        </div>
      </div>
      <Modal
        open={isOpenSalaryPayoutModel}
        onClose={onCloseSalaryPayoutModel}
        classNames="bottom-sheet-modal"
      >
        <div className="p-5">
          <h6 className="text-16 font-bold pb-[10px]"> Update Salary Payout</h6>

          <div className="text-left">
            <h5 className="text-dark-1000 text-16 mb-2 font-semibold">
              Amount
            </h5>
            <TextInputWithIcon
              type="number"
              inputText={salaryPayoutAmount}
              setInputText={setSalaryPayoutAmount}
              placeholder={`Enter salary payout amount`}
            />
            {salaryPayoutAmountEmpty && (
              <p className="text-red-500 text-12">{salaryPayoutAmountEmpty}</p>
            )}
          </div>
          <div className="text-left">
            <h5 className="text-dark-1000 text-16 mb-2 font-semibold">
              Description
            </h5>

            <TextInputWithIcon
              type="text"
              inputText={payoutDescription}
              setInputText={setPayoutDescription}
              placeholder={`Enter payout description`}
            />
          </div>
          <div className="text-left mb-4">
            <p className="text-red-500 text-12">
              **Expense record for this payout will auto updated
            </p>
          </div>

          <div className="flex">
            <button
              className="border-2 font-bold h-10 rounded-[7px] w-1/2 mr-2 border-solid bg-primary text-white"
              onClick={onCloseSalaryPayoutModel}
            >
              Cancel
            </button>
            <button
              color="success"
              className="font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white"
              onClick={!salaryPayoutLoader && salaryPayoutHandler}
            >
              {salaryPayoutLoader ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={20}
                  color={"white"}
                  loading={true}
                />
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
